<template>
  <div>
    <VideoSlider />
  </div>
</template>

<script>
import VideoSlider from "./components/VideoSlider.vue";

export default {
  name: "App",
  components: {
    VideoSlider,
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
